module.exports = __webpack_public_path__ + "media/images/emblems/Wisen-blason-ea602d8e69d108de3b07b3a5404ea253.png";